import { EuiModalHeaderTitle } from '@elastic/eui'

type Props = {
    children: React.ReactElement
}

const ModalHeaderTitle = ({children} :Props) =>
    <EuiModalHeaderTitle>{children}</EuiModalHeaderTitle>

export default ModalHeaderTitle